import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchBarComponent } from '@shared/components/search-bar/search-bar.component';
import { NebularModule } from '@shared/nebular/nebular.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ListViewComponent } from '@shared/components/list-view/list-view.component';
import { ListItemDirective } from '@shared/components/list-view/list-item.directive';
import { AttachmentsCarouselComponent } from './attachments-carousel/attachments-carousel.component';
import { CollapsibleAreaComponent } from './collapsible-area/collapsible-area.component';
import { CoverPageCustomizationComponent } from './cover-page-customization/cover-page-customization.component';
import { AttachmentUploadModule } from '@shared/form-controls/attachment-upload/attachment-upload.module';
import { HauFormsModule } from '@sonofabit/ng-core';
import { GroupedListViewComponent } from './grouped-list-view/grouped-list-view.component';
import {
  GroupedListViewHeaderDirective,
} from '@shared/components/grouped-list-view/grouped-list-view-header.directive';
import { MenuComponent } from '@shared/components/menu/menu.component';
import { ChartComponent } from '@shared/components/chart/chart.component';
import { BarDatasetDirective } from '@shared/components/chart/datasets/bar';
import { LineDatasetDirective } from '@shared/components/chart/datasets/line';
import { PipesModule } from '@shared/pipes/pipes.module';
import { LargeChartComponent } from '@shared/components/chart/large-chart.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { UserListItemComponent } from './user-list-item/user-list-item.component';
import { BuildingListItemComponent } from './building-list-item/building-list-item.component';
import { TeamBadgeComponent } from '@shared/components/team-badge/team-badge.component';
import { TeamPopoverComponent } from '@shared/components/team-badge/team-popover/team-popover.component';
import { TenantBadgeComponent } from '@shared/components/tenant-badge/tenant-badge.component';
import { TenantPopoverComponent } from '@shared/components/tenant-badge/tenant-popover/tenant-popover.component';
import { BuildingBadgeComponent } from '@shared/components/building-badge/building-badge.component';
import {
  BuildingPopoverComponent,
} from '@shared/components/building-badge/building-popover/building-popover.component';
import { UserBadgeComponent } from '@shared/components/user-badge/user-badge.component';
import { UserPopoverComponent } from '@shared/components/user-badge/user-popover/user-popover.component';
import {
  BuildingSectionBadgeComponent,
} from '@shared/components/building-section-badge/building-section-badge.component';
import {
  BuildingSectionPopoverComponent,
} from '@shared/components/building-section-badge/building-section-popover/building-section-popover.component';
import { TgaTypeBadgeComponent } from '@shared/components/tga-type-badge/tga-type-badge.component';
import { TgaTypePopoverComponent } from '@shared/components/tga-type-badge/tga-type-popover/tga-type-popover.component';
import { TeamListItemComponent } from '@shared/components/team-list-item/team-list-item.component';
import { RegionBadgeComponent } from '@shared/components/region-badge/region-badge.component';
import { RegionPopoverComponent } from '@shared/components/region-badge/region-popover/region-popover.component';
import { ShortTagListComponent } from '@shared/components/short-tag-list/short-tag-list.component';
import {
  CustomFieldCollectionsComponent,
} from '@shared/components/custom-field-collections/custom-field-collections.component';
import { CustomFormModule } from '@shared/custom-form/custom-form.module';
import { BannerComponent } from '@shared/components/banner/banner.component';
import { PrivateFolderBadgeComponent } from '@shared/components/private-folder-badge/private-folder-badge.component';
import { YearSelectComponent } from './year-select/year-select.component';
import {
  BuildingEntityBadgeComponent,
} from '@shared/components/building-entity-badge/building-entity-badge.component';
import {
  ProtocolTypeBadgeComponent,
} from '@shared/components/protocol-type-badge/protocol-type-badge.component';
import {
  BuildingEquipmentBadgeComponent,
} from '@shared/components/building-equipment-badge/building-equipment-badge.component';
import { EnergyClassGaugeComponent } from '@shared/components/energy-class-gauge/energy-class-gauge.component';


@NgModule({
  declarations: [
    SearchBarComponent,
    ListViewComponent,
    ListItemDirective,
    AttachmentsCarouselComponent,
    CollapsibleAreaComponent,
    CoverPageCustomizationComponent,
    GroupedListViewComponent,
    GroupedListViewHeaderDirective,
    MenuComponent,
    ChartComponent,
    LargeChartComponent,
    BarDatasetDirective,
    LineDatasetDirective,
    ProgressBarComponent,
    UserListItemComponent,
    BuildingListItemComponent,
    TeamBadgeComponent,
    TeamPopoverComponent,
    TenantBadgeComponent,
    TenantPopoverComponent,
    BuildingBadgeComponent,
    BuildingPopoverComponent,
    UserBadgeComponent,
    UserPopoverComponent,
    BuildingSectionBadgeComponent,
    BuildingSectionPopoverComponent,
    TgaTypeBadgeComponent,
    TgaTypePopoverComponent,
    TeamListItemComponent,
    RegionPopoverComponent,
    RegionBadgeComponent,
    ShortTagListComponent,
    CustomFieldCollectionsComponent,
    BannerComponent,
    PrivateFolderBadgeComponent,
    YearSelectComponent,
    BuildingEntityBadgeComponent,
    BuildingEquipmentBadgeComponent,
    ProtocolTypeBadgeComponent,
    EnergyClassGaugeComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NebularModule,
    AttachmentUploadModule,
    HauFormsModule,
    PipesModule,
    CustomFormModule,
  ],
  exports: [
    SearchBarComponent,
    ListViewComponent,
    ListItemDirective,
    AttachmentsCarouselComponent,
    CollapsibleAreaComponent,
    CoverPageCustomizationComponent,
    GroupedListViewComponent,
    GroupedListViewHeaderDirective,
    MenuComponent,
    ChartComponent,
    LargeChartComponent,
    BarDatasetDirective,
    LineDatasetDirective,
    ProgressBarComponent,
    UserListItemComponent,
    BuildingListItemComponent,
    TeamBadgeComponent,
    TeamPopoverComponent,
    TenantBadgeComponent,
    TenantPopoverComponent,
    BuildingBadgeComponent,
    BuildingPopoverComponent,
    UserBadgeComponent,
    UserPopoverComponent,
    BuildingSectionBadgeComponent,
    BuildingSectionPopoverComponent,
    TgaTypeBadgeComponent,
    TgaTypePopoverComponent,
    TeamListItemComponent,
    RegionPopoverComponent,
    RegionBadgeComponent,
    ShortTagListComponent,
    CustomFieldCollectionsComponent,
    BannerComponent,
    PrivateFolderBadgeComponent,
    YearSelectComponent,
    BuildingEntityBadgeComponent,
    BuildingEquipmentBadgeComponent,
    ProtocolTypeBadgeComponent,
    EnergyClassGaugeComponent,
  ],
})
export class ComponentsModule {
}
